type caliberType = {
  caliberName: string,
  label: string,
}

export const CALIBERS: caliberType[] = [
  {
    caliberName: "Caliber366TKM",
    label: ".366 TKM(9.55x39mm)"
  },
  {
    caliberName: "Caliber86x70",
    label: ".338 Lapua Magnum"
  },
  {
    caliberName: "Caliber9x33R",
    label: ".357 Magnum"
  },
  {
    caliberName: "Caliber1143x23ACP",
    label: ".45 ACP"
  },
  {
    caliberName: "Caliber12g",
    label: "12 gauge"
  },
  {
    caliberName: "Caliber20g",
    label: "20 gauge"
  },
  {
    caliberName: "Caliber23x75",
    label: "23x75mm R"
  },
  {
    caliberName: "Caliber26x75",
    label: "26x75mm flare"
  },
  {
    caliberName: "Caliber40mmRU",
    label: "40mm RU"
  },
  {
    caliberName: "Caliber46x30",
    label: "4.6x30mm"
  },
  {
    caliberName: "Caliber9x18PM",
    label: "9x18mm PM"
  },
  {
    caliberName: "Caliber9x19PARA",
    label: "9x19mm Parabellum"
  },
  {
    caliberName: "Caliber9x21",
    label: "9x21mm"
  },
  {
    caliberName: "Caliber9x39",
    label: "9x39mm"
  },
  {
    caliberName: "Caliber545x39",
    label: "5.45x39mm"
  },
  {
    caliberName: "Caliber556x45NATO",
    label: "5.56x45mm NATO"
  },
  {
    caliberName: "Caliber57x28",
    label: "5.7x28mm FN"
  },
  {
    caliberName: "Caliber762x25TT",
    label: "7.62x25mm TT"
  },
  {
    caliberName: "Caliber762x35",
    label: "7.62x35mm"
  },
  {
    caliberName: "Caliber762x39",
    label: "7.62x39mm"
  },
  {
    caliberName: "Caliber762x51",
    label: "7.62x51mm"
  },
  {
    caliberName: "Caliber762x54R",
    label: "7.62x54mm R"
  },
  {
    caliberName: "Caliber127x55",
    label: "12.7x55mm"
  }
]